import { useEffect } from "react";
import { useTranslations } from "use-intl";

/** Sets `document.title` from a next-intl-style message namespace (e.g. `login.page`). */
export function useDocumentTitle(
  namespace: string,
  titleKey = "title",
): void {
  const t = useTranslations(namespace);

  useEffect(() => {
    try {
      document.title = t(titleKey);
    } catch {
      // Missing key — leave existing title.
    }
  }, [t, titleKey]);
}
